// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_0d624b9a27--checkbox--oMeNF","box":"_0d624b9a27--box--aD_nX","label":"_0d624b9a27--label--iT_qr"};